export var customCssApiRelativePath = "/helpcenter/snippets/css";
export var customCssApiRelativePathV2 = "/helpcenter/snippets/css/v2";
export var customCssApiValidationV2 = "/apps/helpcenter/validate-custom-css";
export var createCustomCssApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + customCssApiRelativePath;
    var apiUrlV2 = "" + baseUrl + customCssApiRelativePathV2;
    return {
        getCustomCss: function (brandId) {
            return http.get("" + apiUrl + (brandId ? "?brandId=" + brandId : ''));
        },
        updateCustomCss: function (dto) { return http.put("" + apiUrl, dto.data); },
        getCustomCssV2: function (brandId) {
            return http.get("" + apiUrlV2 + (brandId ? "?brandId=" + brandId : ''));
        },
        updateCustomCssV2: function (dto) { return http.put("" + apiUrlV2, dto.data); },
        validateCustomCssV2: function (dto) {
            return http.post("https://" + dto.tenantDefaultHost + customCssApiValidationV2, { customCss: dto.customCss });
        }
    };
};
//# sourceMappingURL=index.js.map